export enum ISLabel {
    REVENUES_COHORT = "revenues.cohort",
    REVENUES_NON_COHORT = "revenues.non_cohort",
    REVENUES_NON_COHORT_SEPARATE_COGS = "revenues.non_cohort_separate_cogs",
    REVENUES_NON_COHORT_NO_COGS = "revenues.non_cohort_no_cogs",
    REVENUES_NON_RECURRING = "revenues.non_recurring",
    EXPENSES_D_AND_A = "expenses.D_and_A",
    EXPENSES_GROSS_CASHFLOW_RELATED = "expenses.gross_cashflow_related",
    EXPENSES_NON_CASH_EXPENSES = "expenses.non_cash_expenses",
    EXPENSES_NON_RECURRING = "expenses.non_recurring",
    EXPENSES_OPEX_RELATED = "expenses.opex_related",
    EXPENSES_R_AND_D_RELATED = "expenses.r_and_d_related",
    EXPENSES_REVENUE_RELATED_FINANCIAL_PRINCIPAL_RECOUPMENT = "expenses.revenue_related.financial_principal_recoupment",
    EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT = "expenses.revenue_related.inventory_recoupment",
    EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT_NON_COHORT = "expenses.revenue_related.inventory_recoupment_non_cohort",
    EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS = "expenses.revenue_related.non_inventory_cogs",
    EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS_NON_COHORT = "expenses.revenue_related.non_inventory_cogs_non_cohort",
    INVESTMENTS_SALES_AND_MARKETING = "investments.sales_and_marketing",
    INVESTMENTS_EQUITY = "investments.equity",
    INVESTMENTS_INVENTORY = "investments.inventory",
    INVESTMENTS_LOAN = "investments.loan",
    INVESTMENTS_OTHER = "investments.other",
    BOOKINGS_COHORT = "bookings.cohort",
    BOOKINGS_NON_COHORT = "bookings.non_cohort",
    FINANCING_DEBT_RAISED = "financing.debt_raised",
    FINANCING_DEBT_SERVICES_PRINCIPAL = "financing.debt_services.principal",
    FINANCING_DEBT_SERVICES_INTEREST = "financing.debt_services.interest",
    FINANCING_DEBT_SERVICES_FEES = "financing.debt_services.fees",
    FINANCING_EQUITY_RAISED = "financing.equity_raised",
    FINANCING_EQUITY_SERVICES_PRINCIPAL = "financing.equity_services.principal",
    FINANCING_EQUITY_SERVICES_INCOME = "financing.equity_services.income",
    GROSS_CASHFLOWS_COHORT = "gross_cashflows.cohort",
    GROSS_CASHFLOWS_NON_COHORT = "gross_cashflows.non_cohort",
    GROSS_CASHFLOWS_NON_RECURRING = "gross_cashflows.non_recurring",
    OTHER_INCOME_EXPENSE_NET_OTHER_INCOME = "Other_income/expense_net.Other_income",
    OTHER_INCOME_EXPENSE_NET_OTHER_INCOME_NEGATIVE = "Other_income/expense_net.Other_income_negative",
    OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE = "Other_income/expense_net.Other_expense",
    OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE_NEGATIVE = "Other_income/expense_net.Other_expense_negative",
    REPORTED_NET_INCOME = "reported.net_income",
    REPORTED_COST_OF_GOODS_SOLD = "reported.cost_of_goods_sold",
    REPORTED_GROSS_MARGIN = "reported.gross_margin",
    REPORTED_TOTAL_OPERATING_EXPENSES = "reported.total_operating_expenses",
    REPORTED_EBITDA = "reported.ebitda",
}

export enum BSLabel {
    CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS = "current_assets.cash_and_cash_equivalents",
    CURRENT_ASSETS_DEFERRED_EXPENSES = "current_assets.deferred_expenses",
    CURRENT_ASSETS_DERIVATIVES_AND_HEDGES = "current_assets.derivatives_and_hedges",
    CURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS = "current_assets.net_contracts_with_customers",
    CURRENT_ASSETS_NET_INVENTORY = "current_assets.net_inventory",
    CURRENT_ASSETS_NET_RECEIVABLES = "current_assets.net_receivables",
    CURRENT_ASSETS_OTHER_CURRENT_ASSETS = "current_assets.other_current_assets",
    CURRENT_ASSETS_PREPAID_EXPENSES = "current_assets.prepaid_expenses",
    NONCURRENT_ASSETS_DEFERRED_EXPENSES = "noncurrent_assets.deferred_expenses",
    NONCURRENT_ASSETS_DERIVATIVES_AND_HEDGES = "noncurrent_assets.derivatives_and_hedges",
    NONCURRENT_ASSETS_INVENTORY = "noncurrent_assets.inventory",
    NONCURRENT_ASSETS_LONGTERM_INVESTMENTS_AND_RECEIVABLES = "noncurrent_assets.longterm_investments_and_receivables",
    NONCURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS = "noncurrent_assets.net_contracts_with_customers",
    NONCURRENT_ASSETS_NET_INTANGIBLE_ASSETS_AND_GOODWILL = "noncurrent_assets.net_intangible_assets_and_goodwill",
    NONCURRENT_ASSETS_OTHER_ASSETS = "noncurrent_assets.other_assets",
    NONCURRENT_ASSETS_PREPAID_EXPENSES = "noncurrent_assets.prepaid_expenses",
    NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT = "noncurrent_assets.property_plant_and_equipment",
    NONCURRENT_ASSETS_RESTRICTED_CASH_AND_CASH_EQUIVALENTS = "noncurrent_assets.restricted_cash_and_cash_equivalents",
    CURRENT_LIABILITIES_ACCOUNTS_PAYABLE = "current_liabilities.accounts_payable",
    CURRENT_LIABILITIES_DEBT = "current_liabilities.debt",
    CURRENT_LIABILITIES_DEFERRED_REVENUE = "current_liabilities.deferred_revenue",
    CURRENT_LIABILITIES_DERIVATIVES_AND_HEDGES = "current_liabilities.derivatives_and_hedges",
    CURRENT_LIABILITIES_OTHER_LIABILITIES = "current_liabilities.other_liabilities",
    CURRENT_LIABILITIES_PROVISION_AND_ACCRUALS = "current_liabilities.provision_and_accruals",
    CURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS = "current_liabilities.provision_for_losses_on_contracts",
    CURRENT_LIABILITIES_PROVISION_FOR_REFUNDS = "current_liabilities.provision_for_refunds",
    NONCURRENT_LIABILITIES_ACCOUNTS_PAYABLE = "noncurrent_liabilities.accounts_payable",
    NONCURRENT_LIABILITIES_DEFERRED_REVENUE = "noncurrent_liabilities.deferred_revenue",
    NONCURRENT_LIABILITIES_DERIVATIVES_HEDGES = "noncurrent_liabilities.derivatives_hedges",
    NONCURRENT_LIABILITIES_LONGTERM_DEBT = "noncurrent_liabilities.longterm_debt",
    NONCURRENT_LIABILITIES_OTHER_LIABILITIES = "noncurrent_liabilities.other_liabilities",
    NONCURRENT_LIABILITIES_PROVISION_AND_ACCRUALS = "noncurrent_liabilities.provision_and_accruals",
    NONCURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS = "noncurrent_liabilities.provision_for_losses_on_contracts",
    NONCURRENT_LIABILITIES_PROVISION_FOR_REFUNDS = "noncurrent_liabilities.provision_for_refunds",
    EQUITY_PAID_IN_CAPITAL = "equity.paid_in_capital",
    EQUITY_RETAINED_EARNINGS = "equity.retained_earnings",
    REPORTED_CURRENT_ASSETS = "reported.current_assets",
    REPORTED_NONCURRENT_ASSETS = "reported.noncurrent_assets",
    REPORTED_CURRENT_LIABILITIES = "reported.current_liabilities",
    REPORTED_NONCURRENT_LIABILITIES = "reported.noncurrent_liabilities",
    REPORTED_TOTAL_EQUITY = "reported.total_equity",
}

export enum ExcludedLabel {
    EXCLUDED_BLANK = "excluded.blank",
    EXCLUDED_SUM = "excluded.sum",
    EXCLUDED_DIFFERENCE = "excluded.difference",
    EXCLUDED_UNKNOWN = "excluded.unknown",
}

export const AccountLabels = {
    ...ISLabel,
    ...BSLabel,
    ...ExcludedLabel,
} as const;
export type AccountLabel = (typeof AccountLabels)[keyof typeof AccountLabels];

export interface AccountIdentifier {
    firstSeenAtFile: string;
    accountName: string;
    identifierSource: string;
    codatAccountId: string;
    connectorId: string;
}

export interface Account {
    id: string;
    companyId: string;
    accountName: string;
    label: AccountLabel;
    labelSource: string;
    ignore: boolean;
    isoCurrencyCode: string;
    createdBy: string;
    createdAt: string;
    identifiers: AccountIdentifier[];
}

export enum BalanceSheetCategory {
    ASSETS = "assets",
    LIABILITIES = "liabilities",
    EQUITY = "equity",
}

export enum IncomeStatementCategory {
    REVENUES = "revenues",
    EXPENSES = "expenses",
    INVESTMENTS = "investments",
    BOOKINGS = "bookings",
    FINANCING = "financing",
    GROSS_CASHFLOWS = "GROSS_CASHFLOWS",
    OTHER_INCOME_EXPENSE_NET = "OTHER_INCOME_EXPENSE_NET",
}

export enum OtherCategory {
    REPORTED = "reported",
    EXCLUDED = "excluded",
}

export type AccountCategory =
    | BalanceSheetCategory
    | IncomeStatementCategory
    | OtherCategory;
